export default function WorkshopSection() {
  return (
    <section className="py-16 sm:py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-8">
        <div className="text-center mb-12 sm:mb-16 space-y-4">
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-[#2C2C2C]">
            講座開催のお知らせ
          </h2>
          <p className="text-base sm:text-lg text-[#757575] max-w-3xl mx-auto leading-relaxed">
            初心者の方でも安心して学べる、やさしいCanva基本講座を開催しています
          </p>
        </div>

        <div className="max-w-6xl mx-auto px-4 sm:px-8">
          <div className="bg-gradient-to-br from-[#E8F5E9] to-[#F1F8E9] rounded-3xl p-8 sm:p-12 lg:p-16 shadow-lg">
            <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
              {/* チラシ画像 */}
              <div className="relative h-[500px] lg:h-auto">
                <img 
                  alt="今日から使える！やさしいCanva基本講座 - ぽかぽか堂 よりみち相談室の講座チラシ" 
                  className="w-full h-full object-cover object-top" 
                  src="https://static.readdy.ai/image/a94bf782443eac1605091ed034a69659/1f1e729b96eb3a0d8bab09bf12bd6782.jpeg"
                />
              </div>

              {/* 説明文エリア */}
              <div className="flex-1 space-y-6 text-center lg:text-left">
                <div className="space-y-4">
                  <div className="inline-block bg-gradient-to-r from-[#E8F5E9] to-[#C8E6C9] px-6 py-2 rounded-full">
                    <span className="text-sm sm:text-base font-bold text-[#66BB6A]">生徒さん募集中</span>
                  </div>
                  
                  <h3 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-[#2C2C2C] leading-tight">
                    今日から使える！<br />
                    やさしいCanva基本講座
                  </h3>
                </div>

                <div className="space-y-4 text-[#2C2C2C]">
                  <div className="flex items-start gap-3">
                    <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-1">
                      <i className="ri-user-heart-line text-xl text-[#66BB6A]"></i>
                    </div>
                    <p className="text-base sm:text-lg leading-relaxed">
                      <strong className="font-bold">松伏近辺の店舗様または個人の方</strong>を対象とした、少人数制の丁寧な講座です
                    </p>
                  </div>

                  <div className="flex items-start gap-3">
                    <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-1">
                      <i className="ri-time-line text-xl text-[#66BB6A]"></i>
                    </div>
                    <p className="text-base sm:text-lg leading-relaxed">
                      <strong className="font-bold">おひとりおひとりのペースにあわせて</strong>マンツーマンでサポートします
                    </p>
                  </div>

                  <div className="flex items-start gap-3">
                    <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-1">
                      <i className="ri-palette-line text-xl text-[#66BB6A]"></i>
                    </div>
                    <p className="text-base sm:text-lg leading-relaxed">
                      Canvaの基本操作から、SNS投稿画像やチラシ作成まで、<strong className="font-bold">今日から使える実践的なスキル</strong>が身につきます
                    </p>
                  </div>
                </div>

                <div className="bg-gradient-to-br from-[#E8F5E9] to-[#C8E6C9] rounded-2xl p-6 space-y-3">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 flex items-center justify-center bg-white rounded-full">
                      <i className="ri-message-3-line text-xl text-[#66BB6A]"></i>
                    </div>
                    <p className="text-lg sm:text-xl font-bold text-[#2C2C2C]">
                      お問い合わせ方法
                    </p>
                  </div>
                  <p className="text-base sm:text-lg text-[#2C2C2C] leading-relaxed pl-13">
                    DMまたはプロフィールリンクからお気軽にお問い合わせください
                  </p>
                </div>

                <a
                  href="#contact"
                  className="inline-flex items-center gap-2 px-8 py-4 bg-[#66BB6A] text-white rounded-full font-medium hover:bg-[#5CAA60] transition-colors whitespace-nowrap cursor-pointer text-base"
                >
                  詳細・お申し込みはこちら
                  <i className="ri-arrow-right-line text-xl"></i>
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* 補足情報 */}
        <div className="max-w-4xl mx-auto mt-12 text-center">
          <div className="bg-gradient-to-r from-[#FAF0E6] to-[#F5F5DC] rounded-2xl p-6 sm:p-8">
            <p className="text-base sm:text-lg text-[#2C2C2C] leading-relaxed">
              <i className="ri-information-line text-xl text-[#66BB6A] mr-2"></i>
              パソコンが苦手な方、Canvaを触ったことがない方でも大丈夫です。<br className="hidden sm:block" />
              基礎からゆっくり丁寧にお教えします。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}